import React, { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import { ErrorHandler } from './components/ui/ErrorHandler'
import { AuthenticationProvider } from './contexts/AuthenticationProvider'
import { LayoutProvider } from './contexts/LayoutProvider'
import { ROUTE_BASE_URL } from './routing/routes'
import { ScrollToTop } from './routing/ScrollToTop'
import { GlobalStyle } from './styles/globalStyle'
import { theme } from './styles/themeEstra'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

type Props = {
  children: ReactNode
}

export const Providers = ({ children }: Props): JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={ROUTE_BASE_URL}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <ErrorHandler>
            <AuthenticationProvider>
              <ScrollToTop />
              <LayoutProvider>{children}</LayoutProvider>
            </AuthenticationProvider>
          </ErrorHandler>
        </ThemeProvider>
      </BrowserRouter>
      <ReactQueryDevtools />
    </QueryClientProvider>
  )
}
